import React, {useEffect, useState, useRef} from "react";
import {Button, Col, Form, Input, message, Row, Tabs, TabsProps, Select, DatePicker, Upload, Image, UploadProps, Tag, Tooltip} from "antd";
import {useStore} from "../../store";
import {forEach} from "lodash";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import { addPopular, editPopular, uploadImages, uploadPopular } from "../../http/manager";
import {observer} from "mobx-react";
import styled from "styled-components";
import BraftEditor from "braft-editor";
import { BaseImageUrl } from "../../http/http";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import locale from "antd/es/date-picker/locale/zh_CN";
import dayjs from 'dayjs';
import type { InputRef } from 'antd';

interface ScienceProps {
    onSuccess: ()=> void;
}

const defaultIcon = require("../../image/default-pic.png")

const Science:React.FC<ScienceProps> = ({onSuccess}) => {
    const [form] = Form.useForm();
    const {scienceStore} = useStore();
    const [type, setType] = useState("1");
    const [editorState, setEditorState] = useState(BraftEditor.createEditorState(''));
    const [isCover, setIsCover] = useState(false);
    const [isImgUrl, setIsImgUrl] = useState(false);
    const dataFormat = 'YYYY-MM-DD HH:mm:ss';
    const [tags, setTags] = useState<string[]>([]);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editInputIndex, setEditInputIndex] = useState(-1);
    const [editInputValue, setEditInputValue] = useState('');
    const inputRef = useRef<InputRef>(null);
    const editInputRef = useRef<InputRef>(null);

    useEffect(() => {
        if (scienceStore.detailType === "edit") {
            const { showBaseLibraryDetail } = scienceStore;
            const detail = JSON.parse(JSON.stringify(showBaseLibraryDetail));
            setTags(detail.category ? detail.category.split(',') : []);
            detail.createtime = dayjs(detail.createtime, dataFormat);
            detail.state = detail.state ? detail.state.toString() : '1';
            let userInfo:any = localStorage.getItem('userInfo');
            userInfo = userInfo ? JSON.parse(userInfo) : {};
            const userid:any = userInfo?.id;
            detail.createrId = userid;
            detail.creater = userInfo.username;
            scienceStore.setBaseLibraryDetail(detail);
            setEditorState(BraftEditor.createEditorState(detail.content));

            form.setFieldsValue(detail);
        }
        scienceStore.setSrcFile(null);
        scienceStore.setSrcCoverFile(null);
        scienceStore.clearFileList();
        scienceStore.clearFileCoverList();
        return;
    }, []);

    const tabItems:TabsProps['items'] = [
        {
            key: "1",
            label: "文章信息"
        },
        {
            key: "2",
            label: "文章详情"
        }
    ]

    const coverProps: UploadProps = {
        beforeUpload: (file) => {
            scienceStore.setFileCoverList(file);
            fileCoverToBase(file);
            setIsCover(true);
            return false;
        },
    }

    const fileToBase = (file:any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const src = reader.result;
            scienceStore.setSrcFile(src);
        }
    }

    const props: UploadProps = {
        beforeUpload: (file) => {
            scienceStore.setFilelist(file);
            fileToBase(file);
            setIsImgUrl(true);
            return false;
        },
    }

    const fileCoverToBase = (file:any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const src = reader.result;
            scienceStore.setSrcCoverFile(src);
        }
    }
    const showInput = () => {
        setInputVisible(true);
    }
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    }
    const handleInputConfirm = () => {
        if (inputValue && tags.indexOf(inputValue) === -1) {
          setTags([...tags, inputValue]);
        }
        setInputVisible(false);
        setInputValue('');
    }
    const handleClose = (removedTag: string) => {
        const newTags = tags.filter((tag) => tag !== removedTag);
        setTags(newTags);
    }
    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditInputValue(e.target.value);
    }
    const handleEditInputConfirm = () => {
        const newTags = [...tags];
        newTags[editInputIndex] = editInputValue;
        setTags(newTags);
        setEditInputIndex(-1);
        setEditInputValue('');
    }
    const tagInputStyle: React.CSSProperties = {
        width: 64,
        height: 22,
        marginInlineEnd: 8,
        verticalAlign: 'top'
    };
    
    const tagPlusStyle: React.CSSProperties = {
        height: 22,
        borderStyle: 'dashed'
    };
    const scienceForm = () => {
        return <Form  
                form={form} 
                layout={"vertical"} 
                size={"middle"} 
                style={{minHeight: "600px", overflowY: "auto", overflowX:"hidden"}}
            >
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item label={"分类:"} required={true}>
                        {
                            tags.map((tag, index)=> {
                                if(editInputIndex === index) {
                                    return(
                                        <Input
                                            ref={editInputRef}
                                            key={tag}
                                            size="small"
                                            style={tagInputStyle}
                                            value={editInputValue}
                                            onChange={handleEditInputChange}
                                            onBlur={handleEditInputConfirm}
                                            onPressEnter={handleEditInputConfirm}
                                        />
                                    )
                                }
                                const isLongTag = tag.length > 6;
                                const tagElem = (
                                    <Tag
                                        key={tag}
                                        closable={true}
                                        style={{ userSelect: 'none' }}
                                        color="orange"
                                        onClose={() => handleClose(tag)}
                                    >
                                        <span
                                            onDoubleClick={(e) => {
                                                if (index !== 0) {
                                                    setEditInputIndex(index);
                                                    setEditInputValue(tag);
                                                    e.preventDefault();
                                                }
                                            }}
                                        >
                                            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                                        </span>
                                    </Tag>
                                );
                                return isLongTag ? (
                                    <Tooltip title={tag} key={tag}>
                                        {tagElem}
                                    </Tooltip>
                                ) : (
                                    tagElem
                                );
                            })
                        }
                        {inputVisible ? (
                            <Input
                                ref={inputRef}
                                type="text"
                                size="small"
                                style={tagInputStyle}
                                value={inputValue}
                                onChange={handleInputChange}
                                onBlur={handleInputConfirm}
                                onPressEnter={handleInputConfirm}
                            />
                            ) : (
                            <Tag style={tagPlusStyle} onClick={showInput}>
                                <PlusOutlined /> New Tag
                            </Tag>
                            )}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"标题:"} name={"title"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"数据来源:"} name={"source"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"状态:"} name={"state"} required={true}>
                    <Select
                        options={[
                            { value: '1', label: '发布' },
                            { value: '-1', label: '下线' },
                            { value: '-2', label: '删除' }
                        ]}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"文章作者:"} name={"autor"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"更新时间:"} name={"createtime"} required={true}>
                        <DatePicker locale={locale} format={dataFormat}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"头像:"}>
                        <Upload style={{marginTop:"15px" , marginBottom: "15px"}} showUploadList={false} name={"picture"} maxCount={1} listType="picture-card" {...props} >
                            {(scienceStore.showBaseLibraryDetail?.userImg || scienceStore.srcFile )? <Image preview={false} src={scienceStore.srcFile ? scienceStore.srcFile : BaseImageUrl+scienceStore.showBaseLibraryDetail?.userImg} fallback={defaultIcon}/> : <UploadOutlined/>}
                        </Upload>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={"封面图:"}>
                        <Upload style={{marginTop:"15px" , marginBottom: "15px"}} showUploadList={false} name={"picture"} maxCount={1} listType="picture-card" {...coverProps} >
                            {(scienceStore.showBaseLibraryDetail?.cover || scienceStore.srcCoverFile )? <Image preview={false} src={scienceStore.srcCoverFile ? scienceStore.srcCoverFile : BaseImageUrl+scienceStore.showBaseLibraryDetail?.cover} fallback={defaultIcon}/> : <UploadOutlined/>}
                        </Upload>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    }

    const excludeControls:any = ['emoji', 'code']
    const handleEditorChange = (e:any) => {
        setEditorState(e)
        form.setFieldValue('content', e.toHTML());
    }
    const myUploadFn = (param:any) => {
        const fileType = param.file.type.toLowerCase();
        const params = new FormData();
        params.append("file", param.file);
        params.append("watermark", '0');
        params.append("type", '7');
        if(fileType.indexOf('video') > -1) {
            if(fileType.indexOf('mp4') < 0) {
                message.info("视频上传格式需要为MP4");
                return;
            }
            params.append("video", '1');
        } 
        uploadImages(params)
            .then((res:any) => {
                tryHideFullScreenLoading()
                if (Number(res.code) === 200) {
                  message.success("上传成功");
                  param.success({
                    url: `${BaseImageUrl}${res.data}`,
                    meta: {
                      title: param.file.name,
                      alt: param.file.name
                    }
                  })
                } else {
                    message.error("图片上传失败");
                }
            }).catch(() => {
            message.error("图片上传失败");
            tryHideFullScreenLoading()
        })
      }

    const scienceEditor = ()=> {
        return <EditWrapper>
                <BraftEditor
                    className={"editor-wrapper"}
                    excludeControls={ excludeControls }
                    value={ editorState }
                    onChange={ handleEditorChange }
                    media={{ 
                            uploadFn: myUploadFn, 
                            accepts: { 
                                image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
                                video: 'video/mp4',
                                audio: false
                            },
                            externals: { image: true, video: false, audio: false, embed: false }  
                    }}
                    placeholder="请输入内容"
                />
            </EditWrapper>
    }

    const submit = () => {
        const formFields = form.getFieldsValue(true);
        if(tags.length > 0) {
            formFields.category = tags.join(',')
        }
        const formKeys = Object.keys(formFields);
        form.validateFields(formKeys).then(() => {
            const formData = new FormData();
            forEach(formKeys, (key) => {
                formData.append(key, formFields[key]);
            })
            showFullScreenLoading()

            if (scienceStore.detailType === "add") {
                let userInfo:any = localStorage.getItem('userInfo');
                userInfo = userInfo ? JSON.parse(userInfo) : {};
                const userid:any = userInfo?.id;
                formData.append('createrId', userid);
                formData.append('creater', userInfo.username);
                addPopular(formData).then((res:any) => {
                    if (Number(res.code) === 200) {
                        message.success("添加成功");
                        uploadFile(res.data);
                    }else{
                        message.error("新增失败");
                    }
                }).catch(() => {
                    message.error("新增失败");
                    tryHideFullScreenLoading()
                })
            } else {
                editPopular(formData).then((res:any) => {
                    if (Number(res.code) === 200) {
                        message.success("编辑成功");
                        uploadFile(scienceStore.showBaseLibraryDetail?.id);
                    } else {
                        message.error("编辑失败");
                    }
                }).catch(() => {
                    message.error("编辑失败");
                })
            }
        });
    }

    const uploadFile = (id:any)=> {
        if(isCover) {
            let cFormData = new FormData();
            cFormData.append("file", scienceStore.fileCoverList[0]);
            cFormData.append("watermark", '0');
            cFormData.append("type", '1');
            cFormData.append("id", id);
            uploadPopular(cFormData).then((res:any)=> {
                if(res.code === 200) {
                    if(isImgUrl) {
                        let iFormData = new FormData();
                        iFormData.append("file", scienceStore.fileList[0]);
                        iFormData.append("watermark", '0');
                        iFormData.append("type", '2');
                        iFormData.append("id", id);
                        uploadPopular(iFormData).then((iRes:any)=> {
                            if(iRes.code === 200) {
                                message.success(scienceStore.detailType === "add" ? "新增成功" : "编辑成功");
                                onSuccess();
                            }else{
                                message.error(iRes.message);
                            }
                        }).catch(error=> {
                            message.error(error);
                        })
                    }else{
                        message.success(scienceStore.detailType === "add" ? "新增成功" : "编辑成功");
                        onSuccess();
                    }
                }else{
                    message.error(res.message);
                }
            }).catch(error=> {
                message.error(error);
            })
        }else{
            if(isImgUrl) {
                let iFormData = new FormData();
                iFormData.append("file", scienceStore.fileList[0]);
                iFormData.append("watermark", '0');
                iFormData.append("type", '2');
                iFormData.append("id", id);
                uploadPopular(iFormData).then((iRes:any)=> {
                    if(iRes.code === 200) {
                        message.success(scienceStore.detailType === "add" ? "新增成功" : "编辑成功");
                        onSuccess();
                    }else{
                        message.error(iRes.message);
                    }
                }).catch(error=> {
                    message.error(error);
                })
            }else{
                message.success(scienceStore.detailType === "add" ? "新增成功" : "编辑成功");
                onSuccess();
            }
        }
    }

    const onTabChange = (key: string) => {
        setType(key);
    }

    return (<Wrapper>
        <Tabs items={tabItems} onChange={onTabChange}/>
        <div style={{paddingBottom:"16px"}}>
            {Number(type) === 1 && scienceForm()}
            {Number(type) === 2 && scienceEditor()}
        </div>
        <Button onClick={submit} type={"primary"} size={"large"} style={{margin: "0 auto"}}>提交</Button>
    </Wrapper>);
}

export default observer(Science);

const Wrapper = styled.div`
    & {
      display: flex;
      flex-direction: column;
      height: 700px;
      padding-bottom: 16px;
      .ant-picker{
        width: 100%;
      }
    }
`;

const EditWrapper = styled.div`
    & {
      display: flex;
      flex-direction: column;
      height: 600px;
      .ant-picker{
        width: 100%;
      }
    }
`;